import { ArrowRight, CheckCircle2 } from "lucide-react";
import type { FC } from "react";

import { Button } from "@/components/ui/button";

type Props = {
  /** Firm items this member can still set up (offers Keep Going). */
  firmOpen: number;
  onKeepGoing: () => void;
  onGoHome: () => void;
};

/** Docked above the composer once the personal steps are done. */
export const FinishDock: FC<Props> = ({ firmOpen, onKeepGoing, onGoHome }) => (
  <div
    className="mx-3 flex items-center gap-2 rounded-t-xl border border-b-0 border-line-3 bg-elevated py-2.5 pr-2.5 pl-3 text-base"
    data-testid="onboarding-finish-dock"
  >
    <CheckCircle2 className="size-3.5 shrink-0 text-success" />
    <span className="min-w-0 flex-1 text-fg">
      <span className="font-medium">Setup complete.</span>{" "}
      <span className="text-fg-3">
        {firmOpen
          ? "Firm items wait in your checklist."
          : "Your checklist closes once you leave."}
      </span>
    </span>
    {firmOpen ? (
      <Button variant="secondary" size="sm" onClick={onKeepGoing}>
        Keep Going
      </Button>
    ) : null}
    <Button variant="primary" size="sm" onClick={onGoHome}>
      Go to Home
      <ArrowRight data-icon="inline-end" />
    </Button>
  </div>
);
